import { FC, useState } from "react";
import { Box, Button } from "@mui/material";
import "./LoginCarousel.scss";
import CustomNetworkImage from "../../../components/CustomNetworkImage/CustomNetworkImage";
import ABCDLogo from "../../../assets/images/ABC-Service.jpg";
import { useAppSelector } from "../../../redux-store/CustomReduxHooks";
import mobileLoginStartupBg from "../../../assets/images/login-startup-bg-modified4x.png";
import loginStartupImg1 from "../../../assets/images/login-startup-image1-modified.svg";
import loginStartupImg2 from "../../../assets/images/login-startup-image2-modified.svg";
import useWindowSize from "../../../hooks/useWindowSize";
import { DEVICE_TYPE, iOSType } from "../../../utils/constants";
import { getMobileOperatingSystem } from "../../../utils/helper";
import useDeviceDetection from "../../../hooks/useDeviceDetection";
import LoginStartupTitle from "./LoginStartupTitle";

interface Props {
  setLoginCarousel: Function;
}

const MobileLoginStartup: FC<Props> = ({ setLoginCarousel }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { height } = useWindowSize();
  const deviceType = useDeviceDetection();
  const isMobile = deviceType === DEVICE_TYPE.MOBILE;
  const cmsData = useAppSelector((state) => state.CmsSlice.CmsPageVariableData);
  const cmsLogo =
    cmsData.find((i) => i.attributes.cmsType === "ABC Logo")?.attributes.image
      .data?.attributes.url ?? "";

  const handleNext = () => {
    if (currentIndex === 1) {
      setLoginCarousel(false);
    } else {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }
  };

  const imageStyle: React.CSSProperties = {
    width: "7.125rem",
    height: "2.75rem",
  };

  let btnLabel = currentIndex === 0 ? "Next" : "Let’s get started";
  let imgSrc = currentIndex === 0 ? loginStartupImg1 : loginStartupImg2;
  let title =
    currentIndex === 0
      ? ["We have", "upgraded the", "experience for you"]
      : ["One time", "additional", "security verification"];
  let subTitle =
    currentIndex === 0
      ? ["Login easily with the convenience of", "your ", "mobile number only"]
      : [
          "Authenticate once to sync your",
          "holdings and ",
          "verify your details",
        ];

  return (
    <Box
      className="mobile-login-startup"
      display="flex"
      flexDirection="column"
      sx={{
        backgroundImage: `url(${mobileLoginStartupBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          paddingTop: "1rem",
        }}
      >
        <CustomNetworkImage
          fallBackImage={<img src={ABCDLogo} alt="" style={imageStyle} />}
          src={cmsLogo}
          alt="aditya-birla"
          style={imageStyle}
        />
      </Box>
      <LoginStartupTitle
        title={title}
        subTitle={subTitle}
        isMobile={true}
        image={imgSrc}
        height={height}
      />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        marginTop="1.5rem"
      >
        <Box
          display="flex"
          justifyContent="center"
          marginTop="auto"
          paddingX="1rem"
        >
          <Button
            variant="contained"
            fullWidth
            onClick={handleNext}
            sx={{
              boxShadow: "none",
              marginBottom:
                getMobileOperatingSystem() === iOSType
                  ? "6rem"
                  : isMobile
                  ? "2rem"
                  : "4rem",
              paddingY: ".875rem",
            }}
          >
            {btnLabel}
          </Button>
        </Box>
      </Box>
      <img src={loginStartupImg1} style={{ visibility: "hidden", height: 0 }} />
      <img src={loginStartupImg2} style={{ visibility: "hidden", height: 0 }} />
    </Box>
  );
};

export default MobileLoginStartup;
